import React from "react";
import styled from "styled-components";
import TwitterButton from "./TwitterButton";
import YouTubeButton from "./YouTubeButton";
import Wrapper from "../atoms/Wrapper";
import Link from "../atoms/Link";
import PlaceholderImg from "../../assets/images/hatena.svg";
import AddMyListButton from "./AddMyListButton";
import { count2str } from "../../utils";
import { Badge, BadgeContent } from "../organisms/Ranking";

const StyledWrapper = styled.div`
  display: grid;
  grid-gap: 0.55rem;

  text-align: left;
  max-width: 18rem;

  margin: 1rem 1.8rem 2.2rem;
  text-overflow: ellipsis;
  grid-template-columns: 100%;

  @media (max-width: 450px) {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 100%;
    margin: 1.2rem 0 2rem 0;
  }
`;

const StyledImgWrapper = styled(Wrapper)`
  align-items: flex-start;
  width: 180px;
  height: 180px;
  border-radius: 99999px;
  overflow: hidden;
  background: ${(props) => props.theme.colors.white100};
  box-shadow: 0 2px 6px ${(props) => props.theme.colors.shadow};

  @media (max-width: 450px) {
    width: 120px;
    height: 120px;
    margin-left: 0.3rem;
    margin-right: 0.1rem;
  }
`;

const StyledImg = styled.img`
  height: 180px;

  @media (max-width: 450px) {
    height: 120px;
  }
`;

const Name = styled.span`
  text-overflow: ellipsis;
  font-size: 1.1rem;
  width: 100%;
  line-height: 1.2rem;
  margin-top: 0.2rem;
  margin-bottom: 0.3rem;

  @media (max-width: 450px) {
    padding: 0.1rem 0;
  }
`;

const MyVTuberListsCount = styled(Wrapper)`
  justify-content: flex-start;
  padding-left: 0.4rem;
  line-height: 1.4rem;
  font-size: 0.9rem;
  letter-spacing: 0;
`;
const MyVTuberListsCountLabel = styled(Wrapper)`
  margin-right: 0.5rem;
  color: ${(props) => props.theme.colors.gray};
`;
const MyVTuberListsCountValue = styled(Wrapper)`
  color: ${(props) => props.theme.colors.gray};
`;

const Description = styled(Wrapper)`
  display: grid;
  grid-gap: 0.4rem;
  grid-template-columns: 100%;
  text-align: left;

  @media (max-width: 450px) {
    max-width: calc(100% - 130px);
    width: calc(100% - 130px);
  }
`;

const Group = styled(Wrapper)`
  width: 100%;
  justify-content: flex-start;
  padding-bottom: 0.5rem;
`;

const GroupName = styled.span`
  text-overflow: ellipsis;
  line-height: 0.4rem;
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.gray};
`;

const StyledLink = styled(Link)`
  justify-content: flex-start;
  padding: 0 5px;
`;

const MyList = styled(Wrapper)`
  flex-direction: column;
  align-items: flex-start;
`;

const WeeklyViewCount = styled(Wrapper)`
  color: ${(props) => props.theme.colors.gray};
  font-size: 0.9rem;
  line-height: 1.2rem;
  padding-left: 0.4rem;
  justify-content: start;
`;
const MonthlyViewCount = styled(Wrapper)`
  color: ${(props) => props.theme.colors.gray};
  font-size: 0.9rem;
  line-height: 1.2rem;
  padding-left: 0.4rem;
  margin-bottom: 0.1rem;
  justify-content: start;
`;

const TopInfoAndSep = styled(Wrapper)`
  flex-direction: column;
  padding-top: 0.3rem;
`;

const WeeklySubscriberNumDiff = styled(Wrapper)`
  color: ${(props) => props.theme.colors.gray};
  font-size: 0.9rem;
  line-height: 1.2rem;
  padding-left: 0.4rem;
  margin-top: 0.2rem;
  justify-content: start;

  width: 100%;
  padding-top: 0.5rem;
`;

const Separator = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.border};
  width: calc(100% - 10px);
`;

const WeeklyViewCountLabel = styled(Wrapper)`
  ::after {
    content: "・";
  }
`;
const MonthlyViewCountLabel = styled(Wrapper)`
  ::after {
    content: "・";
  }
`;
const WeeklySubscriberNumDiffLabel = styled(Wrapper)`
  ::after {
    content: "・";
  }
`;
const WeeklySubscriberNumDiffNum = styled(Wrapper)`
  margin-left: 0.25rem;
  font-size: 1rem;
`;
const WeeklyViewCountNum = styled(Wrapper)`
  margin: 0 0.05rem 0;
  font-size: 1rem;
`;
const MonthlyViewCountNum = styled(Wrapper)`
  margin: 0 0.05rem 0;
  font-size: 1rem;
`;

const StyledBadge = styled(Badge)`
  margin: 0;

  @media (max-width: 450px) {
    margin: 0 0.3rem;
  }
`;

const sub2str = (sub) => {
  return (sub > 0 ? "+" : "") + count2str(sub);
};

const StreamItem = (props) => {
  const group =
    props.item.groups && props.item.groups.length > 0 && props.item.groups[0];
  const youtube_channel =
    props.item.youtube_channels &&
    props.item.youtube_channels.length > 0 &&
    props.item.youtube_channels[0];

  return (
    <StyledWrapper id="vtubers-youtube-stream">
      <StyledBadge>
        <StyledImgWrapper>
          <StyledLink to={`/vtubers/${props.item.id}`}>
            <StyledImg
              src={props.item.image}
              alt={props.item.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = PlaceholderImg;
              }}
            />
          </StyledLink>
        </StyledImgWrapper>
        {props.ranking && (
          <BadgeContent rank={props.rank}>{props.rank}</BadgeContent>
        )}
      </StyledBadge>
      <Description>
        <StyledLink to={`/vtubers/${props.item.id}`}>
          <Name>{props.item.name}</Name>
        </StyledLink>
        {group && (
          <StyledLink to={group ? `/groups/${group.id}` : ""}>
            <Group>
              <GroupName>{group && group.name}</GroupName>
            </Group>
          </StyledLink>
        )}
        <YouTubeButton
          youtube={youtube_channel && youtube_channel.youtube_channel_id}
          subscribeCount={youtube_channel && youtube_channel.subscriber_num}
          marginBottom="0.8rem"
        />
        {props.item.twitter_id && (
          <TwitterButton
            twitter_id={props.item.twitter_id}
            placeholder="未設定"
          />
        )}
        <TopInfoAndSep>
          <Separator />
          <WeeklySubscriberNumDiff>
            <WeeklySubscriberNumDiffLabel>週</WeeklySubscriberNumDiffLabel>
            登録者数変動
            <WeeklySubscriberNumDiffNum>
              {props.item && sub2str(props.item.weekly_subscriber_num_diff)}
            </WeeklySubscriberNumDiffNum>
          </WeeklySubscriberNumDiff>
        </TopInfoAndSep>
        <WeeklyViewCount>
          <WeeklyViewCountLabel>週</WeeklyViewCountLabel>
          平均
          <WeeklyViewCountNum>
            {props.item && count2str(props.item.weekly_view_count_average)}
          </WeeklyViewCountNum>
          回視聴/動画
        </WeeklyViewCount>
        <MonthlyViewCount>
          <MonthlyViewCountLabel>月</MonthlyViewCountLabel>
          平均
          <MonthlyViewCountNum>
            {props.item && count2str(props.item.monthly_view_count_average)}
          </MonthlyViewCountNum>
          回視聴/動画
        </MonthlyViewCount>
        <MyList>
          {props.item && props.item.id && (
            <AddMyListButton
              id={props.item.id}
              is_added={props.item.is_added}
              margin="0.2rem 0"
            />
          )}
          <MyVTuberListsCount>
            <MyVTuberListsCountLabel>マイリスト数</MyVTuberListsCountLabel>
            <MyVTuberListsCountValue>
              {props.item.my_vtuber_lists_count
                ? props.item.my_vtuber_lists_count
                : 0}
            </MyVTuberListsCountValue>
          </MyVTuberListsCount>
        </MyList>
      </Description>
    </StyledWrapper>
  );
};

export default React.memo(StreamItem);
